import { render, staticRenderFns } from "./talk_list.vue?vue&type=template&id=ef355656&scoped=true&"
import script from "./talk_list.vue?vue&type=script&lang=js&"
export * from "./talk_list.vue?vue&type=script&lang=js&"
import style0 from "./talk_list.vue?vue&type=style&index=0&id=ef355656&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef355656",
  null
  
)

export default component.exports